import { Fragment } from "react";

import { Element } from "@craftjs/core";

import { prop, define } from "@/components/builder/utils";
import { DnDBypassProvider } from "@/components/builder/utils/bypass-context";

import { FormRadioContainerBlock, FormRadioInputBlock, FormRadioLabelBlock } from "../../..";
import BasePreview from "../../../base";
import { useFormFieldContext } from "../context";

const OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
]

function FormRadioPreview({ ...props }) {
  const { field: { field } } = useFormFieldContext()

  if (field.startsWith('cf')) {
    return <BasePreview {...props}>
      <div>
        {OPTIONS.map((option, index) => <div key={index}>
          <DnDBypassProvider data={option}>
            <Element key={index} is={FormRadioContainerBlock} id={`radio-container-${index}`}>
              <Element key={index} is={FormRadioInputBlock} id={`radio-input-${index}`} />
              <Element key={index} is={FormRadioLabelBlock} id={`radio-label-${index}`} />
            </Element>
          </DnDBypassProvider>
        </div>)}
      </div>
    </BasePreview>
  }

  return <BasePreview {...props}>
    <input type="radio" />
  </BasePreview>
}

export default define('form-radio', FormRadioPreview, Fragment)
  .shared(prop.share('FormRadio', 'form-radio'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({})
  .build()

